import React, { useState, useEffect } from 'react'
import BackToHome from '../../components/back-to-home'
import { Link } from 'react-router-dom'
import bg from '../../assets/images/maintenance.jpg'

export default function PageMaintenance() {
    let [minutes, setMinutes] = useState(0);
    let [remainingSeconds, setRemainingSeconds] = useState(0);

    useEffect(() => {

        let intervalId = setInterval(() => {
            calculateTimeRemaining()
        }, 1000);

        var seconds = 3599;
        function calculateTimeRemaining() {

            let minutes = Math.round((seconds - 30) / 60);
            let remainingSeconds = seconds % 60;

            setMinutes(minutes);
            setRemainingSeconds(remainingSeconds);

            if (seconds === 0) {
                clearInterval(intervalId);
            } else {
                seconds = seconds - 1;
            }
        }
        return () => {
            clearInterval(intervalId);
        };
    }, []);

  return (
    <>
    <BackToHome/> 
    <section className="bg-special d-flex align-items-center" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
        <div className="bg-overlay"></div>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-12 text-center">
                    <Link to="#" className="text-white title-dark logo h5">Leaping<span className="text-primary">.</span></Link>
                    <div className="text-uppercase display-3 fw-bold text-white title-dark mt-2 mb-4 maintenance">We Are Launching Soon</div>
                    <p className="text-white title-dark mx-auto para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 text-center">
                    <div className="text-center">
                        <span id="maintenance" className="timer">{ minutes }:{ remainingSeconds }</span><span className="d-block h6 text-uppercase text-white title-dark">Minutes</span>
                    </div>
                </div>
            </div>

            <div className="row mt-4 pt-2">
                <div className="col-12 text-center">
                    <div className="subcribe-form">
                        <form>
                            <input name="email" id="email" type="email" className="rounded-pill" required="" placeholder="Your email :"/>
                            <button type="submit" className="btn btn-primary rounded-pill">Subscribe</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
